const PROMOTION_USER_ID_KEY = 'promotionUserId';
const PROMOTION_USER_ID_META_KEY = 'promotionUserIdMeta';

export type PromotionUserIdSource = 'deeplink' | 'promotion-code-page' | 'legacy';

interface PromotionUserIdMeta {
  source: PromotionUserIdSource;
  savedAt: string;
}

export const getPromotionUserId = (): string | undefined => {
  try {
    const value = localStorage.getItem(PROMOTION_USER_ID_KEY);
    if (!value) return undefined;
    const normalized = value.trim();
    return normalized.length > 0 ? normalized : undefined;
  } catch (error) {
    console.error('Failed to read promotionUserId from localStorage:', error);
    return undefined;
  }
};

export const savePromotionUserId = (
  promotionUserId: string,
  source: PromotionUserIdSource
): void => {
  const normalized = promotionUserId.trim();
  if (!normalized) return;

  try {
    localStorage.setItem(PROMOTION_USER_ID_KEY, normalized);
    const meta: PromotionUserIdMeta = {
      source,
      savedAt: new Date().toISOString(),
    };
    localStorage.setItem(PROMOTION_USER_ID_META_KEY, JSON.stringify(meta));
  } catch (error) {
    console.error('Failed to save promotionUserId to localStorage:', error);
  }
};

export const clearPromotionUserId = (): void => {
  try {
    localStorage.removeItem(PROMOTION_USER_ID_KEY);
    localStorage.removeItem(PROMOTION_USER_ID_META_KEY);
  } catch (error) {
    console.error('Failed to clear promotionUserId from localStorage:', error);
  }
};
